import { COLORS } from "@app/constants";
import styled from "styled-components";

export const DerivativesTransactionWrapper = styled.div`
  height: 150vh;
  width: 100%;
    overflow: visible;
  //: ${(props) => props.theme.COLORS.bgColor};
  border-left: 1px solid ${(props) => props.theme.COLORS.stroke};
  color: ${COLORS.greyWhite};
    
`;
